// Class that represent the BIMSearch engine
// Connected to a specific BIM360 view
// Allow running filters and creating schedules on elements in the view

import { PropertiesManager } from "./PropertiesManager.js";
import { QuickDataField } from "./ResultClasses";
import { Stages, TestResult, TestTable } from "./ResultClasses";
import { getFromServer, postToServer } from "./CommonFunctions";
import { currentUser } from "./IUsers";
import { logError } from "./IAmecLog";
//import { BimsearchViewer } from "./BimsearchViewer.js";

// Main class for BIMSearch filter and data search
export class BimSearch {
    // public:
    constructor(id) {
        this.projectId = "";

        try {
            this.projectId = id.split("projects/")[1].split("/")[0];
        }
        catch (err) {
            logError("FrontEnd.src.utils.builder.IAmecLog.BimSearch.constructor", err.toString());
        }

        this.init();
    }

    init() {
        this.allElements = [];
        this.propertiesManager = new PropertiesManager();
        this.modelName = "";
    }

    async loadModel(viewer, objectsTree, modelName) {
        this.init();
        this.modelName = modelName;

        objectsTree.enumNodeChildren(
            objectsTree.getRootId(),
            (nodeId) => {
                this.allElements.push(nodeId);
            },
            true
        );

        await this.propertiesManager.loadElements(viewer, this.allElements);

    }

    async findElementsByCategories(categories, categoryIds) {
        var res = [];
        
        if (categories == null) {
            res = this.allElements;
        } else if (categories.length > 0) {
            for (var i = 0; i < this.allElements.length; i++) {
                var props = this.propertiesManager.GetProperties(this.allElements[i]);

                var categoryPropIds = props.properties.filter((prop) => prop.attributeName == "CategoryId" || prop.displayName == "Category Id");
                var categoryPropNames = props.properties.filter((prop) => prop.attributeName == "Category" || prop.displayName == "Category");

                var elementDetected = false;

                if (categoryPropIds.length > 0 && categoryIds.length > 0) {
                    if (categoryIds.includes(categoryPropIds[0].displayValue)) {
                        res.push(this.allElements[i]);
                        elementDetected = true;
                    }
                }
                else if (!elementDetected && categoryPropNames.length > 0 && categories.length > 0) {
                    if (categories.includes(categoryPropNames[0].displayValue.replace(categoryPre, ''))) {
                        res.push(this.allElements[i]);
                        elementDetected = true;
                    }
                }
                else if (!elementDetected && categoryPropIds.length > 0 && categories.length > 0) {
                    if (res.includes(this.categoryIdNameDictionary[categoryPropIds[0].displayValue])) {
                        res.push(this.allElements[i]);
                        elementDetected = true;
                    }
                }
            }
        }
        return res;
    }

    getCounterData(elements) {
        var res = [];
        res.push(new QuickDataField("Count"));
        res.push(new QuickDataField("Length"));
        res.push(new QuickDataField("Area"));
        res.push(new QuickDataField("Volume"));

        for (var i = 0; i < elements.length; i++) {
            var props = this.propertiesManager.GetProperties(elements[i]);
            this.addElementToDataArray(res, props);
        }

        return res;
    }

    getDataByCategory(elements) {
        var res = new Object();

        for (var i = 0; i < elements.length; i++) {
            var props = this.propertiesManager.GetProperties(elements[i]);
            var categoryProp = props.properties.filter((prop) => prop.attributeName == "Category" || prop.displayName == "Category");

            var categoryName = "Unknown";
            if (categoryProp != null && categoryProp.length > 0)
                categoryName = categoryProp[0].displayValue;

            if (res[categoryName] == null) {
                res[categoryName] = [];
                res[categoryName].push(new QuickDataField("Count"));
                res[categoryName].push(new QuickDataField("Length"));
                res[categoryName].push(new QuickDataField("Area"));
                res[categoryName].push(new QuickDataField("Volume"));
            }

            this.addElementToDataArray(res[categoryName], props);
        }
        
        return res;
    }

    async runTest(discipline, stage) {
        var stageInt = Stages[stage];

        var url = `/api/tests/gettestparameters?projectId=${this.projectId}&discipline=${discipline}&stage=${stageInt}`;
        var testParameters = await getFromServer(url);

        var res = new TestResult();
        res.discipline = discipline;
        res.stage = stage;

        var goodProps = 0;
        var allProps = 0;

        Object.keys(testParameters).forEach(category => {
            var catTable = new TestTable();
            catTable.title = category;
            var parameters = testParameters[category];
            catTable.header = ["Type Name", "Count", ...testParameters[category]];

            var typeIndex = {};

            var categoryElements = this.getCategoryElements(category);

            categoryElements.forEach(elementId => {
                var propValues = [];
                var elementProps = this.propertiesManager.GetProperties(elementId);
                parameters.forEach(parameter => {
                    allProps++;
                    var pValue = this.findByDisplayName(elementProps, parameter);
                    if (pValue == null || pValue.displayValue == null || pValue.displayValue == "") {
                        propValues.push("");
                    }
                    else {
                        goodProps++;
                        propValues.push(pValue.displayValue);
                    }
                });

                var typeValue = this.findByDisplayName(elementProps, "Type Name");
                var type = "Missing";
                if (typeValue != null && typeValue.displayValue != null && typeValue.displayValue != "")
                    type = typeValue.displayValue;

                if (typeIndex[type] == null) {
                    typeIndex[type] = catTable.lines.length;
                    catTable.lineElements.push([]);
                    var line = [type, 1, ...propValues];
                    catTable.lines.push(line);
                    var missingArrays = [];
                    for (var i = 0; i < catTable.header.length; i++) {
                        missingArrays.push([]);
                    }
                    catTable.missingProperties.push(missingArrays);
                }
                else {
                    catTable.lines[typeIndex[type]][1]++;
                    for (var i = 0; i < propValues.length; i++) {
                        if (catTable.lines[typeIndex[type]][i + 2] != propValues[i])
                            catTable.lines[typeIndex[type]][i + 2] = "Varies";
                    }
                }

                catTable.lineElements[typeIndex[type]].push(elementId);

                if (type == "Missing")
                    catTable.missingProperties[typeIndex[type]][0].push(elementId);

                for (var i = 0; i < propValues.length; i++) {
                    if (propValues[i] == "")
                        catTable.missingProperties[typeIndex[type]][i + 2].push(elementId);
                }
            });

            for (var i = 0; i < catTable.missingProperties.length; i++)
                for (var j = 0; j < catTable.missingProperties[i].length; j++)
                    if (catTable.missingProperties[i][j].length > 0)
                        catTable.lines[i][j] = catTable.missingProperties[i][j].length + " missing";

            catTable.totals = [catTable.lines.length, categoryElements.length];
            for (var i = 2; i < catTable.header.length; i++)
                catTable.totals.push(null);

            res.tables.push(catTable);
        });

        res.score = allProps == 0 ? 0 : Math.round(goodProps / allProps * 100);
   
        
        //The project id
        var url = "/api/forge/datamanagement/checkedData";
        var data = {
            "discipline": res.discipline,
            "projectId": this.projectId,
            "modelName": this.modelName,
            "lod": this.lodConverter(res.stage),
            "userName": currentUser.userName,
            "date": Date.now(),
            "grade": res.score,
        }
        
        console.log(data);
        postToServer(url, data);
        
        return res;
    }

    // Private:
    lodConverter(stageToLod) {
        var lod = -1;
        switch (stageToLod) {
            case "תכנון ראשוני":
                lod = 100;
                break;
            case "תכנון סופי":
                lod = 200;
                break;
            case "תכנון מפורט":
                lod = 300;
                break;
            case "מידע לביצוע":
                lod = 400;
                break;
            case "אחזקה":
                lod = 500;
                break;
        }
        return lod;
    }

    getCategoryElements(category) {
        var res = [];
        for (var i = 0; i < this.allElements.length; i++) {
            var props = this.propertiesManager.GetProperties(this.allElements[i]);

            var categoryPropNames = props.properties.filter((prop) => prop.attributeName == CategoryParameterName || prop.displayName == CategoryParameterName);
            if (categoryPropNames.length > 0) {
                var elementCategory = categoryPropNames[0].displayValue.replace(categoryPre, "");

                if (elementCategory == category)
                    res.push(this.allElements[i]);
            }
        }

        return res;
    }

    getSharedPropertiesByDisplayName(ids) {
        var propertyNames = [];
        var properties = this.getValidProperties(ids);
        var propertyNames = properties.map(property => property.displayName);

        if (ids.length > 0) {
            var additionalParameterNames = this.getAdditionalParameterNames();

            for (var i = 0; i < additionalParameterNames.length; i++) {
                propertyNames.push(additionalParameterNames[i]);
            }
        }

        propertyNames.sort();
        var uniquePropertyNames = [...new Set(propertyNames)];

        return uniquePropertyNames;
    }

    getSharedPropertiesByAttributeName(ids) {
        var propertyNames = [];
        var properties = this.getValidProperties(ids);
        var propertyNames = properties.map(property => property.attributeName);

        if (ids.length > 0) {
            var additionalParameterNames = this.getAdditionalParameterNames();

            for (var i = 0; i < additionalParameterNames.length; i++) {
                propertyNames.push(additionalParameterNames[i]);
            }
        }

        propertyNames.sort();
        var uniquePropertyNames = [...new Set(propertyNames)];

        return uniquePropertyNames;
    }

    getAdditionalParameterNames() {
        var propNames = [CategoryParameterName, LinkDemiParameterName, FamilyDemiParameterName];
        return this.isRvt() ? propNames : [];
    }

    getValidProperties(ids) {
        var properties = [];
        var proprertyNames = [];

        for (var i = 0; i < ids.length; i++) {
            var props = this.propertiesManager.GetProperties(ids[i]);

            if (props && props.properties && props.properties.length != null)
                for (var j = 0; j < props.properties.length; j++)
                    if ((!proprertyNames.includes(props.properties[j].displayName) && !proprertyNames.includes(props.properties[j].attributeName)) &&
                        !props.properties[j].hidden &&
                        props.properties[j].displayValue != null &&
                        props.properties[j].displayValue !== "" &&
                        ((this.isRvt() && !props.properties[j].hidden) ||
                            (!this.isRvt() && !props.properties[j].displayName.startsWith("Current Control point -") && !props.properties[j].displayName.startsWith("Vertex -")))
                    ) {
                        properties.push(props.properties[j]);
                        proprertyNames.push(props.properties[j].attributeName);
                        proprertyNames.push(props.properties[j].displayName);
                    }
        }

        return properties;
    }

    findByDisplayName(props, value) {
        var res = null;
        
        res = props.properties.find(
            (prop) => (prop.attributeName == value || prop.displayName == value) && prop.hidden == false
        );
        if (res == null) res = props.properties.find((prop) => prop.attributeName == value || prop.displayName == value);

        return res;
    }

    isRvt() {
        return this.modelName.toLowerCase().endsWith(".rvt");
    }

    addElementToDataArray(dataFieldArray, itemProps) {
        var areaParam = this.findByDisplayName(itemProps, "Area");
        var volumeParam = this.findByDisplayName(itemProps, "Volume");
        var lengthParam = this.findByDisplayName(itemProps, "Length");

        dataFieldArray[0].value++;
        addPropertyToDataField(dataFieldArray[1], lengthParam);
        addPropertyToDataField(dataFieldArray[2], areaParam);
        addPropertyToDataField(dataFieldArray[3], volumeParam);
    }
}

const categoryPre = "Revit ";
const LinkDemiParameterName = "Revit Link";
const FamilyDemiParameterName = "Family";
const CategoryParameterName = "Category";

const knownUnits = {
    centimeters: "cm",
    meters: "m",
    squareMeters: "m^2",
    cubicMeters: "m^3"
};

function formatUnit(unitString) {
    if (unitString == null)
        return null;
    var res = unitString;
    if (res.startsWith("autodesk.unit")) {
        var splitUnitString = res.split(":");
        splitUnitString.shift();
        res = splitUnitString.join(":");
        splitUnitString = res.split("-");
        splitUnitString.pop();
        res = splitUnitString.join("-");

        if (Object.keys(knownUnits).includes(res))
            res = knownUnits[res];
    }

    return res;
}

function roundNumber(number) {
    return Math.round(number * 100) / 100;
}

function addPropertyToDataField(dataField, property) {
    if (property != null && typeof property.displayValue == "number") {
        dataField.value += property.displayValue;
        if (property.units != null) {
            var units = formatUnit(property.units);
            if (dataField.unit == null) dataField.unit = units;
            else if (dataField.unit != units) dataField.unit = "Mixed";
        }
    }
}
